import { IDriveDocs } from '../types';
import { IApplicationState } from '../../../../types/types';

export const getDriveDocs = (
    state: IApplicationState
): IDriveDocs => {
    return state.model.driveDocs;
};
